import api from 'api';

export const loadAgencies = api(
  'GET /api/influencers-channels/filters/agencies'
);

export const loadInfluencers = api(
  'GET /api/influencers-channels/filters/influencers'
);

export const loadMasterCampaigns = api(
  'GET /api/influencers-channels/filters/master-campaigns'
);

export const loadCategories = api(
  'GET /api/influencers-channels/filters/categories'
);

export const loadSubCategories = api(
  'GET /api/influencers-channels/filters/sub-categories'
);

export const loadSocialMediaPlatforms = api(
  'GET /api/influencers-channels/filters/social-media-platforms'
);

export const loadCountries = api(
  'GET /api/influencers-channels/filters/countries'
);

export const loadApplications = api(
  'GET /api/influencers-channels/filters/applications'
);
